function _toConsumableArray(arr) {
  return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread();
}
function _nonIterableSpread() {
  throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _iterableToArray(iter) {
  if (typeof Symbol !== "undefined" && Symbol.iterator in Object(iter)) return Array.from(iter);
}
function _arrayWithoutHoles(arr) {
  if (Array.isArray(arr)) return _arrayLikeToArray(arr);
}
function _slicedToArray(arr, i) {
  return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
}
function _nonIterableRest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _unsupportedIterableToArray(o, minLen) {
  if (!o) return;
  if (typeof o === "string") return _arrayLikeToArray(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === "Object" && o.constructor) n = o.constructor.name;
  if (n === "Map" || n === "Set") return Array.from(o);
  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}
function _arrayLikeToArray(arr, len) {
  if (len == null || len > arr.length) len = arr.length;
  for (var i = 0, arr2 = new Array(len); i < len; i++) {
    arr2[i] = arr[i];
  }
  return arr2;
}
function _iterableToArrayLimit(arr, i) {
  if (typeof Symbol === "undefined" || !(Symbol.iterator in Object(arr))) return;
  var _arr = [];
  var _n = true;
  var _d = false;
  var _e = undefined;
  try {
    for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) {
      _arr.push(_s.value);
      if (i && _arr.length === i) break;
    }
  } catch (err) {
    _d = true;
    _e = err;
  } finally {
    try {
      if (!_n && _i["return"] != null) _i["return"]();
    } finally {
      if (_d) throw _e;
    }
  }
  return _arr;
}
function _arrayWithHoles(arr) {
  if (Array.isArray(arr)) return arr;
}
import React, { memo } from 'react';
import PropTypes from 'prop-types';
import { capitalize } from './utils';
import colors from '../../../theme/colors';
import { iconNamesArray, ICONS } from './icon-names';
export var Icon = /*#__PURE__*/memo(function Icon(_ref) {
  var className = _ref.className,
    name = _ref.name,
    size = _ref.size,
    color = _ref.color,
    svgTitle = _ref.svgTitle;
  var _React$useState = React.useState(null),
    _React$useState2 = _slicedToArray(_React$useState, 2),
    SvgIcon = _React$useState2[0],
    setSvgIcon = _React$useState2[1];
  var capitalizedName = capitalize(name);
  var defaultDiv = /*#__PURE__*/React.createElement("div", {
    style: {
      width: iconSizes[size],
      height: iconSizes[size],
      backgroundColor: 'rgba(242, 242, 242,0.2)',
      borderRadius: 50
    },
    className: className
  });
  try {
    import("./svg-icons/components/".concat(capitalizedName)).then(function (module) {
      setSvgIcon(module);
    });
  } catch (e) {
    // console.error("error", e)
    return defaultDiv;
  }
  if (!SvgIcon) {
    return defaultDiv;
  }
  var iconProps = {
    className: className,
    size: iconSizes[size],
    fillColor: color === 'currentColor' ? 'currentColor' : colors[color],
    strokeColor: color === 'currentColor' ? 'currentColor' : colors[color],
    strokeWidth: '0',
    svgClass: 'av-icon',
    svgTitle: svgTitle
  };
  return /*#__PURE__*/React.createElement(SvgIcon.default, iconProps);
});
var iconSizes = {
  tiny: 12,
  xs: 19,
  sm: 24,
  md: 32,
  lg: 48,
  xl: 64
}; // add to utils

var getUpperCasedObjectKeys = function getUpperCasedObjectKeys(object) {
  var objectKeys = Array.isArray(object) ? object : Object.keys(object);
  var upperCasedKeys = {};
  objectKeys.forEach(function (index) {
    upperCasedKeys[index.toUpperCase()] = index;
  });
  return upperCasedKeys;
};
export var SIZES = getUpperCasedObjectKeys(iconSizes);
export var COLORS = getUpperCasedObjectKeys(colors);
export var defaultProps = {
  className: null,
  name: ICONS.Home,
  color: COLORS.MIDNIGHT_LIGHT,
  size: SIZES.MD,
  svgTitle: ''
};
export var propTypes = {
  className: PropTypes.string,
  name: PropTypes.oneOf(iconNamesArray),
  color: PropTypes.oneOf([].concat(_toConsumableArray(Object.keys(colors)), ['currentColor'])),
  size: PropTypes.oneOf(Object.keys(iconSizes)),
  svgTitle: PropTypes.string
};
Icon.defaultProps = defaultProps;